<template>
	
</template>

<script>

import { mapGetters } from "vuex";

export default {
	name: "home-node",
	computed:
	{
		...mapGetters( "nodes", {
			homeNode: "homeNode",
		}),
	},
	created( )
	{
		this.$router.replace( { name : 'node', params : { nodeId : this.homeNode.$id } } );
	}
};
</script>


// WEBPACK FOOTER //
// src/components/HomeNode.vue